import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { combineLatest } from 'rxjs'
import { map } from 'rxjs/operators'
import { Store } from '@ngrx/store'
import { AppState, getUserCenter, canUser, CenterStatus } from 'src/app/@store'
import { ToastrService } from 'ngx-toastr'
import { PermissionTypes, UserPermissionsKeyTypes } from 'src/app/@store/reducers/user.reducer'

@Injectable()
export class VehicleEditGuard implements CanActivate {
  constructor(private store: Store<AppState>, private toaster: ToastrService, private router: Router) {}

  canActivate() {
    return combineLatest([
      this.store.select(getUserCenter),
      this.store.select(canUser, {
        permissionKey: UserPermissionsKeyTypes.Vehicles,
        permissionType: PermissionTypes.Edit,
      }),
    ]).pipe(
      map(([center, canUserEditVehicle]) => {
        if ((!center || center?.open_state === CenterStatus.Closed) && canUserEditVehicle) {
          return true
        }
        const toastErrorMessage = canUserEditVehicle
          ? "Can't create vehicle when center is open for service"
          : "You don't have permissions to perform this action"
        this.toaster.error(toastErrorMessage)
        this.router.navigate(['app/vehicles'])
        return false
      }),
    )
  }
}
